import { AiOutlineHome } from "react-icons/ai";
import { ConfigItem } from "./LayoutTypes";
import { MdCategory } from "react-icons/md";
import {
    FaFlag,
    FaBullhorn,
    FaTag,
    FaBox,
    FaGift,
    FaTicketAlt,
} from "react-icons/fa";
import { HiUsers } from "react-icons/hi";
import { FaCompass } from "react-icons/fa";
import { HiShoppingCart } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import { IoIosNotifications } from "react-icons/io";
import { FaUsers } from "react-icons/fa";

export const Config: ConfigItem[] = [
    {
        Name: "Dashboard",
        Icon: AiOutlineHome,
        Link: "/auth/dashboard",
        isMultiple: false,
    },
    {
        Name: "Banners",
        Icon: FaFlag,
        Link: "/auth/banners",
        isMultiple: false,
    },

    {
        Name: "Explore",
        Icon: FaCompass,
        Link: "/auth/explore",
        isMultiple: false,
    },
    /*  {
        Name: "Exclusive",
        Icon: RiVipCrownLine,
        Link: "/auth/exclusive",
        isMultiple: false,
    }, */
    {
        Name: "Category",
        Icon: MdCategory,
        Link: "/auth/category",
        isMultiple: false,
    },
    {
        Name: "Campaigns",
        Icon: FaBullhorn,
        Link: "/auth/campaigns",
        isMultiple: false,
    },
    {
        Name: "Users",
        Icon: FaUsers,
        Link: "/auth/users",
        isMultiple: false,
    },
    {
        Name: "Orders",
        Icon: HiShoppingCart,
        Link: "/auth/Orders?status=1&page=1",
        isMultiple: false,
    },
    {
        Name: "Prizes",
        Icon: FaGift,
        Link: "/auth/give-away-products",
        isMultiple: false,
    },
    {
        Name: "Promocodes",
        Icon: FaTag,
        Link: "/auth/promocodes",
        isMultiple: false,
    },
    {
        Name: "Products",
        Icon: FaBox,
        Link: "/auth/products",
        isMultiple: false,
    },
    {
        Name: "Lucky Draw",
        Icon: FaTicketAlt,
        Link: "/auth/draw",
        isMultiple: false,
    },
    {
        Name: "Config",
        Icon: IoMdSettings,
        Link: "/auth/config",
        isMultiple: false,
    },
    {
        Name: "Notifications",
        Icon: IoIosNotifications,
        Link: "/auth/notifications",
        isMultiple: false,
    },
];
